import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import network from "./utils/network";
import PageLoading from "./components/module/loading/PageLoading";
import { EVENTS } from "./utils/eventBus";
import PortalOther from "@/views/Other.vue";
import { changeTheme, getCurrentTheme, localFetch, tenantIdFromPath } from "@/utils/util";
import { UI_THEMES as _UI_THEMES } from "@/utils/const";
import { loadLanguageAsync } from "@/plugins/i18n";
import PortalError from "@/views/Error.vue";
import { defineAsyncComponent } from "vue";
import AppLayout from "@/layouts/AppLayout.vue";
import Toast from "primevue/toast";
export default {
  name: "PortalHome",
  methods: {
    getCurrentTheme: getCurrentTheme
  },
  components: {
    AppLayout: AppLayout,
    PortalError: PortalError,
    PortalOther: PortalOther,
    PageLoading: PageLoading,
    Toast: Toast,
    LoadingIndicator: defineAsyncComponent(function () {
      return import("@/components/module/loading/LoadingIndicator");
    })
  },
  computed: {
    tenantIdFromPath: tenantIdFromPath,
    UI_THEMES: function UI_THEMES() {
      return _UI_THEMES;
    },
    isLoginLayout: function isLoginLayout() {
      return this.$route.meta ? this.$route.meta.loginLayout : false;
    },
    showSidebar: function showSidebar() {
      return !this.$route.meta || !this.$route.meta.hideSidebar;
    },
    configLoaded: function configLoaded() {
      return this.$store.getters["uiConfigStore/isLoaded"] || ["SignIn", "Other", "NotFound"].includes(this.$route.name);
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var axios, storedLocale, _this$$store$getters$, fetchedLocale, _t, _t2, _t3;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _this.tenantId = _this.tenantIdFromPath;
            network.configure(_this.$store, _this.$router, _this.$toast);
            axios = network.createAxiosInstance();
            _this.$store.commit("uiConfigStore/setCurrentTheme", localFetch("current_ui_theme"));
            changeTheme(localFetch("current_ui_theme"));

            // eventBus.$on(EVENTS.PAGE_LOADING, () => (this.pageLoaded = false));
            // eventBus.$on(EVENTS.PAGE_LOADED, () => (this.pageLoaded = true));
            _context.n = 1;
            return _this.$store.dispatch("env/fetch");
          case 1:
            storedLocale = localFetch("stored_locale");
            if (!storedLocale) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return loadLanguageAsync(storedLocale);
          case 2:
            _context.n = 7;
            break;
          case 3:
            if (!_this.$store.getters["session/isReady"]) {
              _context.n = 6;
              break;
            }
            _context.n = 4;
            return _this.$store.dispatch("census_user/fetchProfile");
          case 4:
            fetchedLocale = (_this$$store$getters$ = _this.$store.getters["census_user/profile"]) === null || _this$$store$getters$ === void 0 ? void 0 : _this$$store$getters$.lang;
            if (!fetchedLocale) {
              _context.n = 5;
              break;
            }
            _context.n = 5;
            return loadLanguageAsync(fetchedLocale);
          case 5:
            _context.n = 7;
            break;
          case 6:
            _context.n = 7;
            return loadLanguageAsync("hu");
          case 7:
            if (!(_this.$route.name === "Onboarding")) {
              _context.n = 8;
              break;
            }
            _this.onboardingPage = true;
            return _context.a(2);
          case 8:
            if (!_this.tenantId) {
              _context.n = 14;
              break;
            }
            _context.p = 9;
            _context.n = 10;
            return _this.$store.dispatch("uiConfigStore/fetch", _this.tenantId);
          case 10:
            _this.validTenant = true;
            document.querySelector('link[rel="icon"]').setAttribute("href", process.env.VUE_APP_FAVICON);
            _context.n = 12;
            break;
          case 11:
            _context.p = 11;
            _t = _context.v;
            _this.validTenant = false;
          case 12:
            _context.p = 12;
            _this.tenantExamined = true;
            return _context.f(12);
          case 13:
            _context.n = 15;
            break;
          case 14:
            _this.tenantExamined = true;
          case 15:
            if (!_this.$store.getters["session/isReady"]) {
              _context.n = 17;
              break;
            }
            _t2 = Promise;
            _context.n = 16;
            return _this.$store.dispatch("employee/fetchEmployees");
          case 16:
            _t3 = _context.v;
            _context.n = 17;
            return _t2.all.call(_t2, [_t3]);
          case 17:
            return _context.a(2);
        }
      }, _callee, null, [[9, 11, 12, 13]]);
    }))();
  },
  data: function data() {
    return {
      EVENTS: EVENTS,
      pageLoaded: true,
      tenantId: null,
      tenantExamined: false,
      validTenant: false,
      onboardingPage: false
    };
  }
};